const ownLink = "https://opimisil.com/HFjbcrCj";

const blogs = [
  {
    id: 1,
    date: "2025-01-22",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Tendências de Jogos de Cassino em 2025",
    descr:
      "Descubra as principais tendências do setor de jogos de cassino e como elas impactam a experiência dos jogadores.",
    fullText: `O setor de jogos de cassino continua a evoluir rapidamente em 2025, trazendo novas tecnologias e experiências imersivas para os jogadores.\n
    A integração da realidade aumentada e virtual está ganhando destaque, permitindo que os usuários explorem cassinos virtuais como nunca antes. \n
    Outra tendência importante é a personalização da experiência do jogador, com plataformas oferecendo recomendações baseadas em preferências e histórico de jogo. \n
    As apostas esportivas online também continuam a crescer, especialmente em mercados emergentes. \n
    Além disso, os bônus exclusivos estão se tornando mais atraentes, com promoções personalizadas que incentivam a fidelidade dos usuários. \n
    A segurança também é um foco importante, com o uso de criptografia avançada para proteger transações e dados dos usuários. \n
    Por fim, a expansão do acesso móvel permite que mais pessoas joguem a qualquer hora e em qualquer lugar, revolucionando a forma como interagimos com jogos de cassino.`,
  },
  {
    id: 2,
    date: "2025-01-18",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Como Maximizar Suas Chances nos Slots",
    descr:
      "Dicas práticas para aumentar suas chances de ganhar nos jogos de slots.",
    fullText: `Os jogos de slots são populares devido à sua simplicidade e potencial de grandes prêmios. \n
    Para maximizar suas chances de ganhar, é importante começar escolhendo slots com alta taxa de retorno ao jogador (RTP). \n
    Aproveitar bônus e rodadas grátis pode aumentar significativamente seu saldo inicial. \n
    É essencial gerenciar seu orçamento e evitar apostas impulsivas, estabelecendo limites claros antes de começar a jogar. \n
    Testar diferentes jogos em modo de demonstração pode ajudar a entender melhor as regras e características de cada slot. \n
    Outra estratégia útil é apostar valores menores para prolongar o tempo de jogo e aumentar as chances de acertos. \n
    Por fim, lembre-se de jogar de forma responsável e aproveitar a experiência como uma forma de entretenimento.`,
  },
  {
    id: 3,
    date: "2025-01-15",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Novas Regulamentações no Setor de Jogos",
    descr:
      "Saiba como as mudanças nas leis de jogos podem impactar o setor em 2025.",
    fullText: `O setor de jogos está passando por mudanças significativas em 2025 devido a novas regulamentações. \n
    Muitos países estão adotando leis mais rigorosas para proteger os jogadores e promover o jogo responsável. \n
    Uma das mudanças mais notáveis é a introdução de limites de gastos e tempo em plataformas online. \n
    Além disso, há um foco crescente na transparência, com cassinos sendo obrigados a divulgar claramente as taxas de retorno ao jogador. \n
    As regulamentações também incentivam o uso de tecnologias para prevenir fraudes e proteger dados dos usuários. \n
    Embora essas mudanças possam apresentar desafios para os operadores, elas são vistas como um passo importante para um setor mais seguro e confiável. \n
    Os jogadores devem estar atentos às novas regras e aproveitar as plataformas que adotam práticas responsáveis.`,
  },
  {
    id: 4,
    date: "2025-01-10",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Os Benefícios dos Bônus de Boas-Vindas",
    descr:
      "Entenda como os bônus de boas-vindas podem melhorar sua experiência de jogo.",
    fullText: `Os bônus de boas-vindas são uma excelente forma de começar sua jornada em cassinos online. \n
    Eles permitem que os jogadores explorem diferentes jogos sem arriscar grandes valores iniciais. \n
    A maioria dos cassinos oferece bônus em forma de créditos adicionais ou rodadas grátis. \n
    Para aproveitar ao máximo, é importante ler os termos e condições, garantindo que você entenda os requisitos de apostas. \n
    Esses bônus são uma ótima oportunidade para experimentar novos jogos e descobrir suas preferências. \n
    Além disso, eles podem ser usados estrategicamente para aumentar suas chances de ganhar prêmios maiores.\n 
    Jogar com responsabilidade é essencial para tirar o melhor proveito dessa vantagem.`,
  },
  {
    id: 5,
    date: "2025-01-05",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Estratégias para Jogos de Mesa",
    descr: "Dicas para dominar jogos de mesa como blackjack e roleta.",
    fullText: `Os jogos de mesa como blackjack e roleta exigem uma combinação de sorte e estratégia. \n
    No blackjack, aprender as regras básicas e a tabela de estratégia pode melhorar significativamente suas chances. \n
    Apostar de forma disciplinada e evitar a busca de recuperação de perdas são práticas recomendadas. \n
    Na roleta, entender as diferentes apostas e probabilidades pode ajudar a tomar decisões mais informadas.\n 
    Outra dica útil é começar com apostas externas, que têm maior probabilidade de retorno. \n
    Jogar com calma e evitar decisões impulsivas são essenciais para uma experiência positiva.\n 
    Aproveite as versões de prática para desenvolver suas habilidades antes de apostar com dinheiro real.`,
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;
    img.alt = data.title;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;
    img.alt = blog.title;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
